import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
// import React from 'react';
import tinymce from 'tinymce/tinymce';
import { Editor } from '@tinymce/tinymce-react';
import 'tinymce/themes/silver';
import 'tinymce/icons/default/icons';
// 编辑器插件plugins
// 更多插件参考：https://www.tiny.cloud/docs/plugins/
import 'tinymce/plugins/image'; // 插入上传图片插件
import 'tinymce/plugins/media'; // 插入视频插件
import 'tinymce/plugins/table'; // 插入表格插件
import 'tinymce/plugins/lists'; // 列表插件
import 'tinymce/plugins/wordcount'; // 字数统计插件
import 'tinymce/plugins/preview';
import 'tinymce/plugins/print';
import 'tinymce/plugins/importcss';
import 'tinymce/plugins/searchreplace';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/autosave';
import 'tinymce/plugins/save';
import 'tinymce/plugins/directionality';
import 'tinymce/plugins/code';
import 'tinymce/plugins/visualblocks';
import 'tinymce/plugins/visualchars';
import 'tinymce/plugins/fullscreen';
import 'tinymce/plugins/link';
import 'tinymce/plugins/template';
import 'tinymce/plugins/codesample';
import 'tinymce/plugins/charmap';
import 'tinymce/plugins/hr';
import 'tinymce/plugins/pagebreak';
import 'tinymce/plugins/nonbreaking';
import 'tinymce/plugins/anchor';
import 'tinymce/plugins/toc';
import 'tinymce/plugins/insertdatetime';
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/imagetools';
import 'tinymce/plugins/textpattern';
import 'tinymce/plugins/noneditable';
import 'tinymce/plugins/help';
import 'tinymce/plugins/quickbars';
import 'tinymce/plugins/paste';
import { request } from '@/shared/io';
import { getApiUrl, NODE_ENV } from '@/shared/utils';
export const TinymceEditor = (props) => {
    tinymce.init({});
    const { value, 
    // initValue,
    baseUrl, disabled, plugins, toolbar, menubar, imageUploadUrl, wordUploadUrl, fileSaveUrl, rtf2htmlUrl, bucket, objectPathPre, gateway, token, height, } = props;
    let rtfht = '';
    let wordFile = null;
    let objectName = null;
    useEffect(() => {
        // @ts-ignore
        window.changeTiny = change;
    }, []);
    const save = () => {
        if (!value) {
            return;
        }
        let formData = new window.FormData();
        let file = new File([value], 'tinymce.html', {
            type: 'text/html;charset=utf-8',
        });
        formData.append('file', file);
        formData.append('bucket', bucket ?? '');
        if (objectName) {
            formData.append('objectName', objectName);
        }
        if (objectPathPre) {
            formData.append('objectPathPre', objectPathPre);
        }
        const fileSaveUrls = fileSaveUrl;
        request(fileSaveUrls, {
            method: 'post',
            requestType: 'form',
            data: formData,
        })
            .then((res) => {
            if (res.code == 200) {
                objectName = res.data.objectName;
                console.log('保存成功');
            }
            else {
                console.log('保存失败', res.code);
            }
        })
            .catch(() => {
            console.log('保存失败');
        });
    };
    const onChange = (e) => {
        const getCont = e;
        props.getValue && props.getValue(getCont);
        props.onChange && props.onChange(getCont);
    };
    const setRtf = (rtf) => {
        rtfht = rtf;
    };
    const rtf2html = (data) => {
        if (!rtfht || rtfht == '') {
            return;
        }
        let formData = new FormData();
        const rtfs = rtfht;
        let file = new File([rtfs], 'tinymce.rtf', { type: 'text/rtf' });
        formData.append('file', file);
        const gateways = gateway;
        const url = NODE_ENV === 'production' ? gateways + rtf2htmlUrl : rtf2htmlUrl;
        request(url, {
            data: formData,
            method: 'post',
            headers: {
                responseType: 'blob',
            }
        }).then(res => {
            if (res.code == 200) {
                data.content = '';
                tinymce.activeEditor.setContent(tinymce.activeEditor.getContent() + res.data);
            }
            else {
                console.log('rtf2html失败', res.code);
            }
        }).catch(e => {
            console.log('rtf2html失败', e);
        });
    };
    const getFileExtension = (file) => {
        // console.log(file)
        let idx = file.lastIndexOf('.');
        if (idx === -1) {
            // @ts-ignore
            return fileName;
        }
        else {
            let extension = file.substring(idx + 1).toLowerCase();
            return extension;
        }
    };
    const wordUploder = (api) => {
        let formData = new window.FormData();
        const wordFiles = wordFile;
        formData.append('file', wordFiles);
        const wordUploadUrls = wordUploadUrl;
        api.block('上传中...');
        request(wordUploadUrls, {
            method: 'post',
            requestType: 'form',
            data: formData,
        })
            .then((res) => {
            if (res.code == 200) {
                const val = res.data;
                props.getValue && props.getValue(val);
                props.onChange && props.onChange(val);
                wordFile = null;
                api.unblock();
                api.close();
            }
        })
            .catch(() => {
            api.unblock();
            tinymce.activeEditor.windowManager.alert('导入Word失败');
        });
    };
    function change(that) {
        wordFile = that.files[0];
        tinymce.DOM.setHTML('selectFile', wordFile.name);
    }
    const init = {
        language_url: `${baseUrl}/tinymce/langs/zh_CN.js`,
        language: 'zh_CN',
        // //添加额外的插件
        external_plugins: {
            // powerpaste: `${baseUrl}/tinymce/plugins/powerpaste/plugin.min.js`,
            emoticons: `${baseUrl}/tinymce/plugins/emoticons/plugin.min.js`,
        },
        font_formats: '宋体=宋体;黑体=黑体;仿宋=仿宋;微软雅黑=微软雅黑;楷体-GB2312=楷体-GB2312;Arial=arial;helvetica=helvetica;sans-serif=sans-serif; Courier New=courier new;courier=courier;monospace=monospace; AkrutiKndPadmini=Akpdmi-n',
        powerpaste_word_import: 'merge',
        powerpaste_html_import: 'merge',
        powerpaste_allow_local_images: true,
        paste_data_images: true,
        skin_url: `${baseUrl}/tinymce/skins/ui/oxide`,
        content_css: `${baseUrl}/tinymce/skins/content/default/content.css`,
        height: height,
        plugins: plugins,
        toolbar: toolbar,
        branding: false,
        menubar: menubar,
        // 此处为图片上传处理函数
        // 如需ajax上传可参考https://www.tiny.cloud/docs/configure/file-image-upload/#images_upload_handler
        images_upload_handler: (blobInfo, success, _failure) => {
            let formData = new window.FormData();
            formData.append('file', blobInfo.blob());
            const imageUploadUrls = imageUploadUrl;
            request(imageUploadUrls, {
                method: 'post',
                requestType: 'form',
                data: formData,
            })
                .then((res) => {
                success(res.data?.fileSrcUrl);
            })
                .catch(() => { });
        },
        save_onsavecallback: function () {
            save();
        },
        paste_preprocess: function (_pluginApi, data) {
            rtf2html(data);
        },
        setup: function (editor) {
            //office copy / paste
            editor.on('paste', function (e) {
                const data = e.clipboardData;
                let rtfs = '';
                let html = '';
                let rtfPresent = false;
                let imgPresent = false;
                tinymce.each(data.types, function (value, _index) {
                    if ('text/rtf' === value) {
                        rtfPresent = true;
                        rtfs += data.getData(value);
                    }
                    if ('text/html' === value) {
                        html += data.getData(value);
                        imgPresent = html.indexOf('<img') != -1;
                    }
                });
                setRtf(rtfPresent && imgPresent ? rtfs : null);
            });
            editor.ui.registry.addIcon('file-word', '<svg class="icon" viewBox="0 0 1024 1024" width="25" height="25"><defs><style/></defs><path d="M854.6 288.6L639.4 73.4a32 32 0 00-22.6-9.4H192a32 32 0 00-32 32v832a32 32 0 0032 32h640a32 32 0 0032-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z"/><path d="M528.1 472h-32.2c-5.5 0-10.3 3.7-11.6 9.1L434.6 680l-46.1-198.7a12 12 0 00-11.7-9.3h-35.4a12 12 0 00-11.6 15.1l74.2 276a12 12 0 0011.6 8.9h32a12 12 0 0011.6-8.9l52.8-197 52.8 197a12 12 0 0011.6 8.9h31.8a12 12 0 0011.6-8.9l74.4-276a12 12 0 00-11.6-15.1H647a12 12 0 00-11.7 9.3l-45.8 199.1-49.8-199.3a11.9 11.9 0 00-11.6-9.1z"/></svg>');
            const dialog = (_editor) => {
                return {
                    title: '导入Word',
                    body: {
                        type: 'panel',
                        items: [
                            {
                                type: 'grid',
                                columns: 2,
                                items: [
                                    {
                                        type: 'button',
                                        text: '选择文件',
                                        primary: true,
                                        name: 'selectFileButton',
                                    },
                                    {
                                        type: 'htmlpanel',
                                        html: '<div id="selectFile"></div>',
                                    },
                                ],
                            },
                            {
                                type: 'htmlpanel',
                                html: `<input type="file" id="wordFile" name="wordFile" style="display: none" accept=".doc,.docx" onchange=window.changeTiny(this) />`,
                            },
                            {
                                type: 'alertbanner',
                                level: 'info',
                                text: '请选择Word（*.doc、*.docx）格式文件',
                                icon: 'notice',
                            },
                        ],
                    },
                    buttons: [
                        {
                            type: 'cancel',
                            text: 'Cancel',
                        },
                        {
                            type: 'submit',
                            text: 'Ok',
                        },
                    ],
                    // @ts-ignore
                    onAction: function (_api, details) {
                        if (details.name == 'selectFileButton') {
                            const input = document.getElementById('wordFile');
                            // @ts-ignore
                            input.click();
                        }
                    },
                    // @ts-ignore
                    onSubmit: function (api) {
                        // @ts-ignore
                        const wordFile = document.getElementById('wordFile').value;
                        if (!wordFile) {
                            tinymce.activeEditor.windowManager.alert('请选择Word（*.doc、*.docx）格式文件');
                            return;
                        }
                        const extension = getFileExtension(wordFile);
                        if (extension != 'doc' && extension != 'docx') {
                            tinymce.activeEditor.windowManager.alert('请选择Word（*.doc、*.docx）格式文件');
                            return;
                        }
                        tinymce.activeEditor.windowManager.confirm('导入将覆盖编辑器所有内容，是否继续！', function (s) {
                            if (s) {
                                wordUploder(api);
                            }
                        });
                    },
                };
            };
            editor.ui.registry.addButton('importWord', {
                icon: 'file-word',
                tooltip: '导入Word',
                onAction: () => {
                    const dialogConfig = dialog(editor);
                    editor.windowManager.open(dialogConfig);
                },
            });
        },
    };
    return (_jsx("div", { children: _jsx(Editor, { init: init, value: props.value, disabled: disabled, onEditorChange: onChange }) }));
};
TinymceEditor.defaultProps = {
    value: '',
    baseUrl: `${getApiUrl()}/public`,
    disabled: false,
    plugins: 'print preview paste importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media template codesample table  hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable help charmap quickbars emoticons',
    toolbar: 'importWord | undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ltr rtl',
    menubar: 'file edit view insert format tools table help',
    imageUploadUrl: '/api/minio/v1/file/public',
    wordUploadUrl: '/api/minio/v1/file/word2html',
    fileSaveUrl: '/api/minio/v1/file',
    rtf2htmlUrl: '/api/minio/v1/file/rtf2html',
    bucket: 'test',
    objectPathPre: 'a/test',
    height: 600,
    gateway: `${getApiUrl()}`,
    token: sessionStorage.getItem('ACCESS_TOKEN'),
};
